import { Link } from "@tanstack/react-router";

import { BadgeIcon } from "@/components/Icon/BadgeIcon";
import { HStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";

type Step = {
  label: string;
  hash: string;
};

type Props = {
  baseLink: string;
  currentHash: string;
  isError?: boolean;
  steps: Step[];
  step: Step;
  stepIndex: number;
};

const AddStepperNavigationStepItemNoStepper = ({
  baseLink,
  currentHash,
  isError,
  steps,
  step,
  stepIndex,
}: Props) => {
  // NoStepper の場合は Active かどうかのみで表現
  const status = (() => {
    const stepOrder = steps.findIndex((step) => step.hash === currentHash);
    if (stepIndex === stepOrder) return "active";
    return "not-active";
  })();

  const isActive = status === "active";

  const styles = (() => {
    if (isActive && isError) {
      return {
        container:
          "p-3 text-error-on-muted-fill rounded-md bg-error-muted-fill font-semibold",
        badgeType: "error" as const,
        textColor: "text-error-on-muted-fill",
      };
    }
    if (isError) {
      return {
        container:
          "p-3 text-error-on-muted-fill hover:bg-error-muted-fill hover:text-error hover:shadow-xs",
        badgeType: "error" as const,
        textColor: "text-error-on-muted-fill",
      };
    }
    if (isActive) {
      return {
        container:
          "p-3 rounded-md bg-primary-muted-fill font-semibold text-primary",
        badgeType: "check" as const,
        textColor: "text-primary-on-neutral-fill",
      };
    }
    return {
      container:
        "p-3 text-muted-foreground hover:bg-primary-muted-fill hover:text-primary hover:shadow-xs",
      badgeType: "check" as const,
      textColor: "text-neutral-muted-on-fill",
    };
  })();

  return (
    <Link to={baseLink} hash={step.hash} className={styles.container}>
      <HStack className="items-center gap-1.5">
        <BadgeIcon count={stepIndex + 1} type={styles.badgeType} />
        <Text variant="label" className={`text-sm ${styles.textColor}`}>
          {step.label}
        </Text>
      </HStack>
    </Link>
  );
};

export default AddStepperNavigationStepItemNoStepper;
